import { api } from "./api";
import { adaptSources } from "@/lib/adapters";

/** Resolve playable sources ONLY when the user presses play. */
export async function getVideo(id, { episode, signal } = {}) {
  const res = await api.get(`/movies/${encodeURIComponent(id)}/video`, { signal, params: episode ? { episode } : undefined });
  return { sources: adaptSources(res), episode: res.episode || null, next: res.next || null };
}

export const getProgress = (id) => api.get(`/progress/${encodeURIComponent(id)}`);
export const saveProgress = (id, position, duration, episodeId) => api.put(`/progress/${encodeURIComponent(id)}`, { position, duration, episode_id: episodeId || null });
